import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/migration')({
  component: () => <Navigate replace search to="/bo/migration" />,
})
